import { useState, useEffect } from 'react';
import { ShippixCreateShipment, ShippixVolume } from '../types/shippix';
import dayjs from 'dayjs';

export const STORAGE_KEY = 'modal_shipment_state';

interface ModalShipmentState {
  shipment: ShippixCreateShipment;
  volumes: ShippixVolume[];
  isChargeEnabled: boolean;
  selectedVolumeType: string;
}

export function useModalShipmentState() {
  // Estado inicial padrão
  const defaultState: ModalShipmentState = {
    shipment: {
      service: '',
      sender_country: 'PT',
      recipient_country: 'PT',
      volumes: 1,
      weight: 1,
      date: dayjs().format('YYYY-MM-DD'),
      volume_items: [],
      charge_price: 0
    },
    volumes: [{ weight: '', length: '', width: '', height: '' }],
    isChargeEnabled: false,
    selectedVolumeType: 'outro'
  };

  // Função para carregar o estado do sessionStorage
  const loadState = (): ModalShipmentState => {
    try {
      const savedState = sessionStorage.getItem(STORAGE_KEY);
      if (savedState) {
        return JSON.parse(savedState);
      }
    } catch (error) {
      console.error('Erro ao carregar estado:', error);
    }
    return defaultState;
  };

  // Inicializa o estado com os dados salvos ou o estado padrão
  const [state, setState] = useState<ModalShipmentState>(loadState);

  // Salva o estado no sessionStorage sempre que houver mudanças
  useEffect(() => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      console.error('Erro ao salvar estado:', error);
    }
  }, [state]);

  // Função para limpar o estado
  const clearState = () => {
    setState(defaultState);
    sessionStorage.removeItem(STORAGE_KEY);
  };

  return {
    state,
    setState,
    clearState
  };
}
